import { FormControl, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material';
import { AUDIT_LOGS_TEST_IDS } from 'pages/AuditLogs/AuditLogs.testIds';
import { AuditLogExportShortcutsProps } from './AuditLogExportShortcuts.props';

const customRangeSelectSx = {
  '& .MuiInputLabel-root, & .MuiInputLabel-root.Mui-focused': { color: 'warning.main' },
  '& .MuiOutlinedInput-notchedOutline': { borderColor: 'warning.main' },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'warning.dark' },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'warning.main' },
};

const AuditLogExportShortcuts = ({
  isCustomRange,
  monthOptions,
  onMonthChange,
  onWeekChange,
  selectedMonth,
  selectedWeek,
  weekOptions,
}: AuditLogExportShortcutsProps) => (
  <Stack spacing={2}>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <FormControl fullWidth sx={isCustomRange ? customRangeSelectSx : undefined}>
        <InputLabel id="audit-log-export-month-label">Month</InputLabel>
        <Select
          labelId="audit-log-export-month-label"
          label="Month"
          value={selectedMonth}
          onChange={event => onMonthChange(event.target.value)}
          data-testid={AUDIT_LOGS_TEST_IDS.exportMonthSelect}>
          {monthOptions.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl fullWidth sx={isCustomRange ? customRangeSelectSx : undefined}>
        <InputLabel id="audit-log-export-week-label">Week (optional)</InputLabel>
        <Select
          labelId="audit-log-export-week-label"
          label="Week (optional)"
          value={selectedWeek}
          onChange={event => onWeekChange(event.target.value)}
          data-testid={AUDIT_LOGS_TEST_IDS.exportWeekSelect}>
          <MenuItem value="">Entire month</MenuItem>
          {weekOptions.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
    {isCustomRange && (
      <Typography variant="body2" color="warning.main" data-testid={AUDIT_LOGS_TEST_IDS.exportCustomRangeNote}>
        Custom range. The selected month and week no longer match these dates.
      </Typography>
    )}
  </Stack>
);

export default AuditLogExportShortcuts;
